import { BingoVersionList } from './verions.js';

export interface IBingoCommon {
  clientId: string;
  version: BingoVersionList;
  mainColor: string;
  backgroundColor: string;
  textFont: string;
  isFileRequired: boolean;
  isScoreboard: boolean;
}

export class BingoCommonClass implements IBingoCommon {
  clientId: string;
  version: BingoVersionList;
  mainColor: string;
  backgroundColor: string;
  textFont: string;
  isFileRequired: boolean;
  isScoreboard: boolean;

  constructor(bingo?: Partial<IBingoCommon>) {
    this.clientId = bingo?.clientId ?? '';
    this.version = bingo?.version ?? BingoVersionList.BINGOV1;
    this.mainColor = bingo?.mainColor ?? '';
    this.backgroundColor = bingo?.backgroundColor ?? '';
    this.textFont = bingo?.textFont ?? '';
    this.isFileRequired = bingo?.isFileRequired ?? true;
    this.isScoreboard = bingo?.isScoreboard ?? true;
  }
}
